import { apiClient } from '@/libs/axios';
import type { ApiResponse } from '@/types/api.type';
import { mutationOptions } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { z } from 'zod';
import type { User } from '../types/user.type';

export const UpdateUserSchema = z.object({
  full_name: z.string().min(1, {
    message: 'Nama lengkap tidak boleh kosong!',
  }),
  email: z.email({ message: 'Email tidak valid!' }),
  gender: z.enum(['male', 'female']).optional(),
  phone_number: z
    .string()
    .regex(/^\+62\d{8,12}$/, {
      message:
        'Nomor telepon harus diawali +62 dan merupakan nomor Indonesia yang valid',
    })
    .optional(),
  type: z.enum(['MENTOR', 'USER']).optional(),
});
export type UpdateUserData = z.infer<typeof UpdateUserSchema>;
export type UpdateUserPayload = {
  user_id: string;
  data: UpdateUserData;
};
export type UpdateUserResponse = ApiResponse<User>;

export const updateUser = async (
  payload: UpdateUserPayload
): Promise<UpdateUserResponse> => {
  const { user_id, data } = payload;
  const url = `user/${user_id}`;

  return await apiClient.patch(url, data);
};

export function updateUserMutationOptions() {
  return mutationOptions<UpdateUserResponse, AxiosError, UpdateUserPayload>({
    mutationFn: updateUser,
  });
}
